/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChangeOrderTemplatesControllerFindAllQueryResponse, ChangeOrderTemplatesControllerFindAllQueryParams, ChangeOrderTemplatesControllerFindAll401, ChangeOrderTemplatesControllerFindAll403 } from "../../models/changeOrderTemplatesController/ChangeOrderTemplatesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { changeOrderTemplatesControllerFindAll } from "../../clients/change-order-templatesService/changeOrderTemplatesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const changeOrderTemplatesControllerFindAllQueryKey = (params: ChangeOrderTemplatesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/change-order-templates'
}, ...(params ? [params] : [])] as const;
export type ChangeOrderTemplatesControllerFindAllQueryKey = ReturnType<typeof changeOrderTemplatesControllerFindAllQueryKey>;
export function changeOrderTemplatesControllerFindAllQueryOptions(params?: ChangeOrderTemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = changeOrderTemplatesControllerFindAllQueryKey(params);
  return queryOptions<ChangeOrderTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerFindAll401 | ChangeOrderTemplatesControllerFindAll403>, ChangeOrderTemplatesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return changeOrderTemplatesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List a project's change order templates (filter[scopeId] required, filter[kind] optional)
 * {@link /api/v1/change-order-templates}
 */
export function useChangeOrderTemplatesControllerFindAll<TData = ChangeOrderTemplatesControllerFindAllQueryResponse, TQueryData = ChangeOrderTemplatesControllerFindAllQueryResponse, TQueryKey extends QueryKey = ChangeOrderTemplatesControllerFindAllQueryKey>(params?: ChangeOrderTemplatesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ChangeOrderTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerFindAll401 | ChangeOrderTemplatesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? changeOrderTemplatesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...changeOrderTemplatesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ChangeOrderTemplatesControllerFindAll401 | ChangeOrderTemplatesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}